/// <amd-module name="DRITools/DRIToolsHub/Callgraph/CallgraphFilterBar" />
import * as React from "react";

// VSS
import { isGuid } from "VSS/Core/Util/String";

// VSSUI
import { FilterBar } from "VSSUI/FilterBar";
import { KeywordFilterBarItem } from "VSSUI/TextFilterBarItem";
import {
    Filter,
    FILTER_APPLIED_EVENT,
    IFilterState,
} from "VSSUI/Utilities/Filter";

// DRITools
import * as Resources from "DRITools/DRIToolsHub/Resources";

export interface ICallgraphFilterBar {
    onApply: (id: string) => void;
    onError: () => void;
}

export class CallgraphFilterBar extends React.Component<ICallgraphFilterBar> {
    private filter: Filter;

    constructor(props: ICallgraphFilterBar) {
        super(props);

        this.filter = new Filter({ useApplyMode: true });

        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("id");

        this.filter.setFilterItemState("IdFilterItem", {
            value: id && isGuid(id) ? id : ""
        });

        this.filter.subscribe((state: IFilterState, action: string) => {
            if (state["IdFilterItem"]) {
                const currentId = state["IdFilterItem"]!.value;
                if (isGuid(currentId)) {
                    this.props.onApply(currentId);
                } else {
                    this.props.onError();
                }
            }
        }, FILTER_APPLIED_EVENT);
    }

    public render(): JSX.Element {
        return (
            <FilterBar filter={this.filter} hideClearAction>
                <KeywordFilterBarItem
                    clearable
                    filterItemKey="IdFilterItem"
                    maxTextLength={36}
                    placeholder={Resources.Callgraph_Label_TextInput}
                />
            </FilterBar>
        );
    }
}
